import { getEntries } from '../../services/journal/entries.service'

// MF-67 — Journal entries list slice.
export const UPDATE_JOURNAL_ENTRIES_LIST = 'UPDATE_JOURNAL_ENTRIES_LIST'
export const TOGGLE_JOURNAL_ENTRIES_LOADING = 'TOGGLE_JOURNAL_ENTRIES_LOADING'
export const JOURNAL_ENTRIES_ERROR = 'JOURNAL_ENTRIES_ERROR'
export const JOURNAL_ENTRIES_UPDATE_TOTAL = 'JOURNAL_ENTRIES_UPDATE_TOTAL'

export const updateEntriesList = (value = []) => ({
  type: UPDATE_JOURNAL_ENTRIES_LIST,
  payload: { value }
})

export const entriesError = (value = null) => ({
  type: JOURNAL_ENTRIES_ERROR,
  payload: { value }
})

export const toggleLoadingEntries = (value = false) => ({
  type: TOGGLE_JOURNAL_ENTRIES_LOADING,
  payload: { value }
})

export const updateTotalEntries = (value = 0) => ({
  type: JOURNAL_ENTRIES_UPDATE_TOTAL,
  payload: { value }
})

export const loadEntries = (params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingEntries(true))
      dispatch(entriesError())

      const { data } = await getEntries(params)

      dispatch(updateEntriesList(data?.paginatedResults ?? []))
      dispatch(updateTotalEntries(data?.totalRecords ?? 0))
    } catch (error) {
      dispatch(updateEntriesList([]))
      dispatch(updateTotalEntries(0))
      dispatch(entriesError(error?.message ?? 'error'))
    } finally {
      dispatch(toggleLoadingEntries(false))
    }
  }
}
